import { type FC } from "react"
import { CreateListForm } from "@/components/Favorites/CreateListForm"
import { Button } from "@/ui/Button/Button"
import { Modal } from "@/ui/Modal"

export const CreateListButton: FC = () => {
  return (
    <Modal
      title="Добавить список"
      closeMode="destroy"
      disclosure={
        <Button icon={"PlusCircle"} variant={"link"} isClean size={"smallM"}>
          Создать список
        </Button>
      }
    >
      <CreateListForm />
    </Modal>
  )
}
